import React, { useContext, useEffect, useState } from 'react';
import { isDesktop } from '../../utils/ScreenSizeHelper';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import GreetingUser from '../../utils/greetingUser';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import variables from '../../utils/assets/_variables.scss';
import AtomicButton from '../../atomic/button/Button';
import SIMLE_FACE from '../../utils/assets/png/SmileFace.png';

const MenuTabsHeaders = () => {
  const navigate = useNavigate();
  const [lastSelectedItem, setLastSelectedItem] = useState('orderdashboard');
  const { onLogout } = useContext(SignUpDataContext);
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);

  const { KitchenInfo, kitchenOperationObject } = onLoadInfoResponse?.data?.data?.data || {};
  const RedirectToLogin = async () => navigate('/login');

  const StoreDisplayName =
    kitchenOperationObject?.display_name || kitchenOperationObject?.kitchen_name;
  const Email = KitchenInfo?.email;
  const FirstName = KitchenInfo?.firstName;

  const package_plan = onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.package_plan;

  useEffect(() => {}, [lastSelectedItem]);

  const handleItemSelectionToggle = async (event, itemId, isSelected) => {
    if (isSelected) {
      if (itemId === 'orderdashboard') {
        navigate('/');
      }

      if (itemId === 'menu') {
        navigate('/menu');
      }

      if (itemId === 'uploadmenuimage') {
        navigate('/uploadmenuimage');
      }

      if (itemId === 'discount') {
        navigate('/discountsettings');
      }

      if (itemId === 'deliverydrivers') {
        navigate('/deliverydrivers');
      }

      if (itemId === 'revenuesharing') {
        navigate('/referralstatistics');
      }

      if (itemId === 'accountinfo') {
        navigate('/accountinfo');
      }

      if (itemId === 'storesettings') {
        navigate('/storesettings');
      }

      setLastSelectedItem(itemId);
    }
  };

  const triggerLogout = async () => {
    await onLogout();
    await RedirectToLogin();
    window.location.reload();
  };

  return (
    <div
      style={{
        display: 'flex',
        padding: isDesktop ? '60px 20% 50px 30%' : '60px 10% 50px 20%',
        flexDirection: 'column',
      }}
    >
      <SimpleTreeView
        onItemSelectionToggle={handleItemSelectionToggle}
        defaultSelectedItems={lastSelectedItem}
        className='menu-tree-style'
        selectedItems={lastSelectedItem}
      >
        <div>
          <div style={{ position: 'relative' }}>
            <SpaceDashboardOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='orderdashboard'
              label='Order Dashboard'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'orderdashboard' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <MenuBookOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='menu'
              label='Menu'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'menu' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <LocalOfferOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='discount'
              label='Discount'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'discount' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          {package_plan == 'basic' && (
            <div style={{ position: 'relative' }}>
              <LocalShippingOutlinedIcon
                sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
              />
              <TreeItem
                itemId='deliverydrivers'
                label='Delivery Driver'
                sx={{
                  backgroundColor: 'transparent',
                  color: lastSelectedItem === 'deliverydrivers' ? 'hwb(23 16% 0%)' : 'black',
                }}
              />
            </div>
          )}
        </div>

        <div style={{ marginLeft: '20px', marginRight: '10px' }}>
          <div style={{ position: 'relative' }}>
            <SettingsOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='storesettings'
              label='Store Settings'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'storesettings' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <AccountCircleOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='accountinfo'
              label='Account Info'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'accountinfo' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <AnalyticsOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='revenuesharing'
              label='Referral Stats'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'revenuesharing' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <ImageOutlinedIcon
              sx={{ fontSize: '25px', color: 'black', position: 'absolute', top: 5, left: 2 }}
            />
            <TreeItem
              itemId='uploadmenuimage'
              label='Upload Menu Image'
              sx={{
                backgroundColor: 'transparent',
                color: lastSelectedItem === 'uploadmenuimage' ? 'hwb(23 16% 0%)' : 'black',
              }}
            />
          </div>

          {/* <TreeItem itemId='manage deliveries' label='Manage Deliveries'>
            <TreeItem itemId='manage drivers' label='Manage drivers' />
          </TreeItem> */}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            // borderLeft: '1px solid rgba(209, 220, 242, 1)',
            marginLeft: '20px',
          }}
        >
          <div style={{ width: '70px', marginLeft: '10px' }}>
            <img
              src={SIMLE_FACE}
              alt='Handshake'
              style={{
                width: '50px',
                height: 'auto',
              }}
            />
          </div>

          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                // marginLeft: '30px',
              }}
            >
              <a
                style={{
                  color: 'black',
                  marginRight: '10px',
                  fontSize: '16px',
                  fontFamily: 'Inter Medium',
                }}
              >
                {GreetingUser()}
              </a>

              <a
                style={{
                  color: 'black',
                  marginRight: '10px',
                  fontSize: '16px',
                  textTransform: 'capitalize',
                  fontFamily: 'Inter Bold',
                }}
              >
                {' '}
                {FirstName}
              </a>
            </div>

            <div
              style={{
                color: 'black',
                marginRight: '25px',
                fontSize: '16px',
                fontFamily: 'Inter ExtraLight',
                textTransform: 'capitalize',
                marginTop: '10px',
                // marginLeft: '60px',
              }}
            >
              {StoreDisplayName}
            </div>
            <div
              style={{
                color: 'black',
                marginRight: '25px',
                fontSize: '14px',
                fontFamily: 'Inter ExtraLight',
                marginTop: '5px',
                // marginLeft: '60px',
              }}
            >
              {Email}
            </div>

            <AtomicButton
              label='Logout'
              style={{
                // marginLeft: '60px',
                zIndex: 1,
                width: '100px',
                color: 'white',
                marginTop: '20px',
                backgroundColor: '#181436',
                fontSize: '12px',
                height: '30px',
              }}
              handleSubmit={triggerLogout}
              endIcon={''}
              startIcon={<LogoutIcon sx={{ width: '20px' }} />}
            />
          </div>
        </div>
      </SimpleTreeView>
    </div>
  );
};

export default MenuTabsHeaders;
